<!-- 同意画面コンポーネント -->
<template>
  <div v-if="isVisible" class="consent-overlay">
    <div class="consent-dialog">
      <div class="consent-content">
        <h2>{{ $t('consent.title') }}</h2>
        <p>{{ $t('consent.message1') }}</p>
        <p>{{ $t('consent.message2') }}</p>
        <div class="consent-buttons">
          <button class="btn-yes" @click="handleYes">{{ $t('consent.agree') }}</button>
          <button class="btn-no" @click="handleNo">{{ $t('consent.disagree') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsentDialog',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['response'],
  setup(props, { emit }) {
    const handleYes = () => {
      console.log('handleYes');
      emit('response', true);
    };

    const handleNo = () => {
      console.log('handleNo');
      emit('response', false);
    };

    return {
      handleYes,
      handleNo
    };
  }
};
</script>

<style scoped>
.consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.consent-dialog {
  padding: 32px 22px 24px 22px;
  width: 90%;
  max-width: 679px;
  border-radius: 30px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #eaeaea;
  background-color: #fafbfb;
}

.consent-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.consent-content h2 {
  margin-bottom: 16px;
  font-family: "NotoSans-Bold";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1.92px;
  text-align: center;
  color: #dc6e6e;
}

.consent-content p {
  max-width: 580px;
  margin-bottom: 32px;
  text-align: left;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-weight: 500;
  line-height: 1.86;
  letter-spacing: 0.56px;
  color: #002850;
}

.consent-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.btn-yes, .btn-no {
  width: 310px;
  height: 60px;
  padding: 12px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  
  font-family: "NotoSans-Bold";
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.8px;
  text-align: center;
}

.btn-no {
  background-color: white;
  color: #4797d5;
  border: 1px solid #4797d5;
}

.btn-yes {
  background-color: #4797d5;
  color: white;
}

/* 英語対応 */
@media (max-width: 564px) {
  #app.lang-en .consent-content p{
    font-size: 13px;
  }
}

</style> 